import { Component, type ErrorInfo, type ReactNode } from "react";
import {
  APP_VERSION,
  BUILD_ID,
  BUILD_LABEL,
  reloadWithFreshAssets,
  runtimeDiagnostics
} from "../buildInfo";

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  error: Error | null;
}

export class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  state: AppErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Egel Planner runtime failure", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    const details = runtimeDiagnostics(this.state.error.message);

    return (
      <main className="fatal-screen" role="alert">
        <section className="fatal-card">
          <div className="fatal-card__mark">E</div>
          <span className="fatal-card__eyebrow">Egel Design Planner</span>
          <h1>Конфигуратор не смог запуститься</h1>
          <p>
            Обновите приложение. Ваш проект хранится отдельно и после
            обновления останется на месте.
          </p>
          <button type="button" onClick={reloadWithFreshAssets}>
            Обновить конфигуратор
          </button>
          <small>
            Версия {APP_VERSION} · {BUILD_LABEL} · {BUILD_ID}
          </small>
          <details>
            <summary>Техническая информация</summary>
            <pre>{details}</pre>
          </details>
        </section>
      </main>
    );
  }
}
